export default __webpack_public_path__ + "static/media/aiko.56d7ea0f.png";